"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFeatureFlagsString = void 0;
const constants_1 = require("./constants");
const parseFeatureFlagsString = (headerValue) => {
    const flags = headerValue ? headerValue.split(constants_1.FLAG_DELIMITER) : [];
    return flags.reduce((featureFlags, flag) => {
        const [name, value] = flag.split(constants_1.NAME_VALUE_DELIMITER);
        return value
            ? Object.assign(Object.assign({}, featureFlags), { [name]: value }) : featureFlags;
    }, {});
};
exports.parseFeatureFlagsString = parseFeatureFlagsString;
